import { useState, useEffect } from 'react';
import { Content } from '@ynap/api-utils';
import { raygun } from '@ynap/clientside-monitoring';
import { useConfig, useAppState } from '@ynap/immutables-provider';
import 'cross-fetch/polyfill';

const configSelector = (config) => ({
    baseUrl: config?.global.services.content.baseUrl,
    clientId: config?.global.services.content.clientId,
    brandId: config?.global.application.brandId,
});

export const useContentByComponentKey = ({ componentKey, markdown = 'gitMarkdown', normalize }) => {
    const { baseUrl, brandId, clientId } = useConfig(configSelector);
    const { country, language, langISO: coreMediaLocale } = useAppState() || {};

    const [content, setContent] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const request = Content.getContentByComponent({
            baseUrl,
            brandId,
            country,
            language,
            componentKey,
            clientId,
            coreMediaLocale,
            options: {
                mv: markdown,
                noCommerce: true,
                f: 'ycos',
            },
        });

        const fetchContent = async () => {
            setLoading(true);
            const normalizedData = await fetchData(request, componentKey, normalize);
            setContent(normalizedData);
            setLoading(false);
        };

        fetchContent();
    }, [componentKey]);

    return {
        content,
        loading,
    };
};

const fetchData = async (request, componentKey, normalize) => {
    let response, jsonResponses;
    try {
        response = await fetch(request);
    } catch (error) {
        return (
            raygun &&
            raygun.helpers.agent('send', {
                error: new Error(`Content componentKey: ${componentKey} fetching error`),
                tags: [`content-${componentKey}`],
                customData: error,
            })
        );
    }

    try {
        jsonResponses = await response.json();
    } catch (error) {
        return (
            raygun &&
            raygun.helpers.agent('send', {
                error: new Error(`Content componentKey: ${componentKey} parsing error`),
                tags: [`content-${componentKey}`],
                customData: error,
            })
        );
    }
    return normalize ? normalize(jsonResponses) : jsonResponses;
};
